import * as React from "react";
import { FvcAnalysisSet } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { ParameterType } from "../../../misc/api/ParameterTypes";
import { FvcRepeatability, calculateFvcRepeatabilityTopTwoNew } from "../../Shared/RepeatabilityCalculations";
import { DynamicResultsGroupHeading } from "../../Shared/ResultsGroupHeading";
import { useResultsContext } from "../UseResultsContext";

interface TopTwoRepeatabilityProps {
    analysisSet: FvcAnalysisSet;
    acceptabilityChange: boolean;
}

export const TopTwoRepeatability = ({ analysisSet, acceptabilityChange }: TopTwoRepeatabilityProps) => {
    const { additionalColumnCount } = useResultsContext();
    const { fvcSettings } = useCurrentStudyConfigurationContext();
    const [fvcRepeatability, setFvcRepeatability] = React.useState<FvcRepeatability>(null);

    React.useEffect(() => {
        const repeatability = calculateFvcRepeatabilityTopTwoNew(analysisSet.tests, fvcSettings.IndividualAcceptabilitiesEnabled);
        setFvcRepeatability(repeatability);
    }, [analysisSet, acceptabilityChange]);

    if (!fvcRepeatability)
        return null;

    const displayedFEV1 = fvcSettings["SelectedTestParameters"]?.find(ap => ap === ParameterType.Fev1);
    const displayedFVC = fvcSettings["SelectedTestParameters"]?.find(ap => ap === ParameterType.Fvc);

    if (!displayedFEV1 && !displayedFVC)
        return null;

    return (
        <>
            <DynamicResultsGroupHeading resultsCount={analysisSet.tests.length} title="Repeatability" />
            {displayedFVC ? <tr>
                <td colSpan={analysisSet.tests.length + 1}>FVC</td>
                <td colSpan={additionalColumnCount - 1}>
                    {fvcRepeatability.fvcAbsolute !== null ? fvcRepeatability.fvcAbsolute?.toFixed(2) : "-"}L ({fvcRepeatability.fvcPercentage !== null ? fvcRepeatability.fvcPercentage?.toFixed(2) : "-"}%)
                </td>
            </tr> : null}
            {displayedFEV1 ? <tr>
                <td colSpan={analysisSet.tests.length + 1}>FEV1</td>
                <td colSpan={additionalColumnCount - 1}>
                    {fvcRepeatability.fev1Absolute !== null ? fvcRepeatability.fev1Absolute?.toFixed(2) : "-"}L ({fvcRepeatability.fev1Percentage !== null ? fvcRepeatability?.fev1Percentage?.toFixed(2) : "-"}%)
                </td>
            </tr> : null}
        </>
    )

    
}
